module.exports = {
      id: "ios-usage",
      viewBox: "0 0 114 35",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#ios",
      toString: function () {
        return this.url;
      }
    }